<div class="platform-fields" [formGroup]="adapterForm">
  <div class="form-field">
    <label class="required-label">HEC URL</label>
    <input matInput formControlName="hecUrl" placeholder="https://splunk-staging.example.com:8088/services/collector" />
    @if (adapterForm.get('hecUrl')?.hasError('invalidHttpsUrl') && adapterForm.get('hecUrl')?.touched) {
      <small class="error-text">{{ adapterForm.get('hecUrl')?.errors?.['invalidHttpsUrl']?.message }}</small>
    }
  </div>

  <div class="form-field">
    <label [class.required-label]="!isEditMode">HEC Token</label>
    <input
      matInput
      type="password"
      formControlName="hecToken"
      [placeholder]="isEditMode ? 'Leave unchanged or enter new token' : 'Enter HEC token (UUID format)'"
    />
    @if (adapterForm.get('hecToken')?.hasError('invalidUuid') && adapterForm.get('hecToken')?.touched) {
      <small class="error-text">HEC Token must be in UUID format (e.g., 550e8400-e29b-41d4-a716-446655440000)</small>
    }
  </div>

  <div class="form-field">
    <label class="required-label">Index</label>
    <input matInput formControlName="index" placeholder="staging_security" />
  </div>
</div>
